const ROLE_ALIASES = {
  editor: 'patternmaker',
  viewer: 'support',
};

export const normalizeRole = (role) => {
  const normalized = String(role || '').trim().toLowerCase();
  if (!normalized) return '';
  return ROLE_ALIASES[normalized] || normalized;
};

export const isOwner = (role) => normalizeRole(role) === 'owner';
export const isAdmin = (role) => normalizeRole(role) === 'admin';
export const isPatternmaker = (role) => normalizeRole(role) === 'patternmaker';
export const isSupport = (role) => normalizeRole(role) === 'support';

export const canAccessUserManagement = (role) => isOwner(role) || isAdmin(role);
export const canAccessManagePatterns = (role) => isOwner(role) || isAdmin(role) || isPatternmaker(role);
export const canAccessBackupManagement = (role) => isOwner(role) || isAdmin(role);
export const canEditPatternCanvas = (role) => isOwner(role) || isAdmin(role) || isPatternmaker(role);
export const canSavePatternVersion = (role) => isOwner(role) || isAdmin(role) || isPatternmaker(role);
export const canDeleteHistoricalPatterns = (role) => isOwner(role) || isAdmin(role);
export const canCreateOrEditClients = (role) => isOwner(role) || isAdmin(role) || isPatternmaker(role);
export const canDeleteClients = (role) => isOwner(role) || isAdmin(role);
export const canSavePrintLayoutPreview = (role) => isOwner(role) || isAdmin(role) || isPatternmaker(role) || isSupport(role);

export const getAssignableRoles = (actorRole) => {
  if (isOwner(actorRole)) {
    return ['owner', 'admin', 'patternmaker', 'support'];
  }
  if (isAdmin(actorRole)) {
    return ['patternmaker', 'support'];
  }
  return [];
};
